import { useTranslations } from 'next-intl';

import { SpecialIcon as ButtonIcon } from '@/component/Buttons/SpecialIcon/SpecialIcon';
import { MinusIcon } from '@/component/Icons/MinusIcon';
import { PlusIcon } from '@/component/Icons/PlusIcon';

import styles from './Counter.module.css';

export function Counter({ value, title, min = 0, onChange, dataTestid }) {
  const t = useTranslations();
  const val = Number(value) || min;

  return (
    <div className={styles.counter} data-testid={dataTestid}>
      <div>
        <div className={styles.counter__title}>{title}</div>
      </div>
      <div className={styles.counter__controls}>
        <ButtonIcon
          disabled={val === min}
          onClick={() => onChange(Math.max(min, val - 1))}
          data-testid="counter-button-decrease"
        >
          <MinusIcon />
        </ButtonIcon>
        <span className={styles.counter__value}>
          {val === 0 ? t('listings.filters.rooms.any') : `${val}+`}
        </span>
        <ButtonIcon
          onClick={() => onChange(val + 1)}
          data-testid="counter-button-increase"
        >
          <PlusIcon />
        </ButtonIcon>
      </div>
    </div>
  );
}
